module.exports = __webpack_public_path__ + "img/noble-level5-img.5df40932.png";